import {ReviewActionTypes, UserActionTypes} from "../Actions/actionTypes";


export const initialAnalyseState = {
    summaryList: [],
    isLoading: false,
    currentUserId: null,
};

const getUserScopeId = (user) => {
    if (!user || typeof user !== "object") return null;
    return user.id || user.user_id || user.data?.id || user.data?.user_id || null;
};

export const analyseReducer = (state = initialAnalyseState, action) => {
    switch (action.type) {
        case UserActionTypes.SET_AUTH:
            if (action.payload === false) {
                return { ...initialAnalyseState };
            }
            return state;
        case UserActionTypes.SET_CURRENT_USER: {
            const nextUserId = getUserScopeId(action.payload);
            if (!nextUserId) return state;
            if (state.currentUserId && state.currentUserId !== nextUserId) {
                return { ...initialAnalyseState, currentUserId: nextUserId };
            }
            return { ...state, currentUserId: nextUserId };
        }
        case ReviewActionTypes.CLEAR_ANALYSES_SUMMARY:
            return {
                ...state,
                summaryList: [],
                isLoading: false,
            };
        case ReviewActionTypes.SET_LOADING:
            if (action.payload === true) {
                return { ...state, summaryList: [], isLoading: true };
            }
            return { ...state, isLoading: action.payload };
        case  ReviewActionTypes.SET_ANALYSES_SUMMARY:
            return {...state, summaryList: Array.isArray(action.payload) ? action.payload : [], isLoading: false};
        case  ReviewActionTypes.REMOVE_ANALYSE_SUMMARY:
            return {
                ...state,
                summaryList: state.summaryList.filter(
                    analyse => analyse.id !== action.payload
                )
            }
        default:
            return state;
    }
};
